﻿import { BaseResponse } from './base-response.model'

export class ConfirmResponse extends BaseResponse {
}